
import User from '@/components/User.vue'
import Tables from '@/components/common/TablesDb.vue'
import InputText from '@/components/common/InputText.vue'
import { useApi } from '@/lib/api'
import { defineComponent, ref, computed, watch, markRaw } from 'vue'
import { useRoute } from 'vue-router'
import { downloadStream } from '@/lib/common'
import { useStore } from 'vuex'

const userType = markRaw({
  template: `<span>{{data.b2b === true ? 'B2B':'Spletni'}}</span>`,
  props: {
    data: {}
  }
})

export default defineComponent({
  components: { Tables, InputText, User },
  setup() {
    const _store = useStore()
    const _api = useApi()
    const _route = useRoute()
    const cols = ref([
      { field: 'id', caption: '#', dbField: 'id', hidden: true },
      { field: 'userAdmin', caption: 'Administrator', dbField: 'uporadmin' },
      { field: 'idUser', caption: 'ID uporabnika', dbField: 'id_user' },
      { field: 'user', caption: 'Uporabnik', dbField: 'upor' },
      { field: 'b2b', caption: 'Tip uporabnika', dbField: 'A.b2b', component: userType },
      { field: 'active', caption: 'Aktivnost uporabnika', dbField: 'U.aktiven', format: { type: 'yesno' } },
      { field: 'admin', caption: 'Pravica admin', dbField: 'U.admin', format: { type: 'yesno' } },
      { field: 'superAdmin', caption: 'Pravica superadmin', dbField: 'U.superadmin', format: { type: 'yesno' } },
      { field: 'date', caption: 'Datum', format: { type: 'date', format: 'DD.MM.YYYY HH:mm' }, dbField: 'A.date_create' }
    ])
    const data = ref([])
    const filter = ref({ pagerPage: 1, pagerPageSize: 20, pagerSort: 'A.id desc' })
    const hasId = computed(() => _route.params.id)

    const getData = async (e?: any, f?: any) => {
      if (!hasId.value) {
        if (e) {
          filter.value.pagerPage = e.page
          filter.value.pagerSort = e.sort ? e.sort : 'A.id desc'
        } else if (filter.value.pagerPage > 1) {
          if (f) {
            filter.value.pagerPage = 1
          }
          return
        }
        const res = await _api.post<any>('adminRevisionList', filter.value, true)
        data.value = res.data
      }
    }

    const toXls = async () => {
      _store.commit('appLoading', true)
      try {
        const res = await _api.axios.post<any>('adminRevisionList?export=true', filter.value, { responseType: 'blob' })
        if (res.status === 200) {
          downloadStream(res.data, 'Revizijska_sled.xlsx')
        }
      } finally {
        _store.commit('appLoading', false)
      }
    }

    watch(hasId, () => getData())

    getData()

    return { cols, data, filter, getData, hasId, toXls }
  }
})
